// Material
import { styled } from '@mui/material/styles'
import { alpha, Button } from '@mui/material'

const StyledButton = styled(Button)<{ dataColor?: 'neutral000' }>`
  color: ${({ theme, dataColor }) =>
    alpha(
      dataColor === 'neutral000'
        ? theme.palette.neutral000
        : theme.palette.primary.main,
      0.9,
    )};
  border-color: ${({ theme, dataColor }) =>
    alpha(
      dataColor === 'neutral000'
        ? theme.palette.neutral000
        : theme.palette.primary.main,
      0.9,
    )};
  border-radius: 12px;
  padding: 5px 12px;

  .MuiButton-startIcon {
    margin-left: 4px;
    margin-right: 0;
  }
  &:hover {
    color: ${({ theme, dataColor }) =>
      dataColor === 'neutral000'
        ? theme.palette.neutral000
        : theme.palette.primary.main};
    border-color: ${({ theme, dataColor }) =>
      dataColor === 'neutral000'
        ? theme.palette.neutral000
        : theme.palette.primary.main};
  }

  ${({ theme }) => ({ ...theme.typography.subtitle3 })},
`

interface Props {
  title: string
  onClick: () => any
  icon?: any
  color?: 'neutral000'
  size?: 'small' | 'medium' | 'large'
}
export function RoundedOutlinedButton({
  title,
  icon,
  onClick,
  color,
  size = 'medium',
}: Props) {
  return (
    <StyledButton
      variant="outlined"
      startIcon={icon}
      onClick={onClick}
      dataColor={color}
      size={size}
    >
      {title}
    </StyledButton>
  )
}
